const GIFT_CARD_MSG_MAX_LENGTH = 125;
const INTERSTICE_DELAY_MS = 1000; //1000 ms delay for interstice for checkout,

const PAYMENT_LOGO_SIZE = {
    width: 50,
    height: 32
};

const PAYMENT_ERROR_CODES = [
    413, // paymentServiceError
    416, // generalPaymentServiceError
    420 //  createPaymentError
];

const DELIVERY_ISSUES_MODAL = {
    somethingWrongMessageScreen: 'SomethingWrongMessageScreen',
    universalSorryMessageScreen: 'UniversalSorryMessageScreen',
    eligibleForReplacementScreen: 'EligibleForReplacementScreen'
};

const PAZE_ERROR_MESSAGES = {
    incompleteCheckout: 'INCOMPLETE',
    inaccesible: 'ACCT_INACCESSIBLE',
    invalidData: 'CLIENT_DATA_INVALID'
};

const SHIPPING_METHODS = {
    SAME_DAY_UNSCHEDULED: 'SAME_DAY_UNSCHEDULED'
};

// Values for the `cartType` query param sent on `GET /api/checkout/orders/{orderId}`.
// Must match the literal used by the inline head scripts (main.headScript.js /
// newAuth.headScript.js) that build the same URL before the main bundle loads.
const LAST_INIT_CART_TYPE = {
    BOPIS: 'BOPIS'
};

// messageContext of the checkout payment-promo banner in items.basketLevelMessages. Kept here (not
// utils/Checkout) so reducers/order can import it without a store import cycle.
const PROMOTION_PAYMENT_BANNER_CONTEXT = 'promotion.payment.banner';

export {
    DELIVERY_ISSUES_MODAL,
    GIFT_CARD_MSG_MAX_LENGTH,
    INTERSTICE_DELAY_MS,
    LAST_INIT_CART_TYPE,
    PAYMENT_LOGO_SIZE,
    PAYMENT_ERROR_CODES,
    PAZE_ERROR_MESSAGES,
    PROMOTION_PAYMENT_BANNER_CONTEXT,
    SHIPPING_METHODS
};
